import { motion, useInView, Variants } from "framer-motion";
import { ReactNode, RefObject } from "react";

interface TimelineContentProps {
  children: ReactNode;
  animationNum: number;
  timelineRef: RefObject<HTMLElement | null>;
  className?: string;
}

export function TimelineContent({
  children,
  animationNum,
  timelineRef,
  className,
}: TimelineContentProps) {
  const isInView = useInView(timelineRef, { once: true, margin: "-10% 0px" });

  const revealVariants: Variants = {
    visible: (i: number) => ({
      y: 0,
      opacity: 1,
      filter: "blur(0px)",
      transition: {
        delay: i * 0.4,
        duration: 0.5,
      },
    }),
    hidden: {
      filter: "blur(10px)",
      y: -20,
      opacity: 0,
    },
  };

  return (
    <motion.div
      className={className}
      initial="hidden"
      animate={isInView ? "visible" : "hidden"}
      variants={revealVariants}
      custom={animationNum}
    >
      {children}
    </motion.div>
  );
}
